import { render, staticRenderFns } from "./forgetPsw.vue?vue&type=template&id=2fdbeaae&scoped=true"
import script from "./forgetPsw.vue?vue&type=script&lang=js"
export * from "./forgetPsw.vue?vue&type=script&lang=js"
import style0 from "./forgetPsw.vue?vue&type=style&index=0&id=2fdbeaae&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2fdbeaae",
  null
  
)

export default component.exports